const addSaleFormFields = [];
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const Get_URI = (method, data = {}) => {
    switch (method) {
        case "GET":
            return `${REACT_APP_BACKEND_URL}/invoices`;
        case "GET_ITEMS":
            return `${REACT_APP_BACKEND_URL}/items`;
        case "GET_CUSTOMERS":
            return `${REACT_APP_BACKEND_URL}/otherparty/?typeId=2`;

        case "POST":
            return `${REACT_APP_BACKEND_URL}/invoices/create`;
        case "PATCH":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        case "DELETE":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        default:
            return "";
    }
};

export { addSaleFormFields, Get_URI };
